var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Upload and auto-detect file type" },
        on: {
          close: function ($event) {
            return _vm.$emit("refresh")
          },
          close_waring: function ($event) {
            return _vm.closeAutoDetectResult()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function ({ isError }) {
              return [
                isError
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "warning" },
                          },
                          [_vm._v("warning")]
                        ),
                        _vm._v(
                          "\n        File successfully uploaded, but we failed to detect its file type\n      "
                        ),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "success" },
                          },
                          [_vm._v("check_circle")]
                        ),
                        _vm._v(
                          "\n        File successfully uploaded and its file type was detected\n      "
                        ),
                      ],
                      1
                    ),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ FileResults }) {
              return [
                FileResults && FileResults.length > 0
                  ? _c("ul", [
                      _c(
                        "li",
                        { staticClass: "pb-2" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "dataset",
                                  params: { id: FileResults[0].FileId },
                                },
                                target: "_blank",
                              },
                            },
                            [_vm._v("Review the file")]
                          ),
                          _vm._v(
                            " and its contents for any formatting mistakes. Reupload the file if any changes were made.\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("li", { staticClass: "pb-2" }, [
                            _vm._v(
                              "Customize the ingestion service configurations to better suit your file format."
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c(
                            "li",
                            { staticClass: "pb-2" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "dataset",
                                      params: { id: FileResults[0].FileId },
                                    },
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("Manually set the file type")]
                              ),
                              _vm._v(" by editing the file.\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "pb-2" }, [
                        _vm._v(
                          "Contact your administrator or Hatfield if you require assistance."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "next",
            fn: function ({ FileResults }) {
              return [
                _c(
                  "PrimaryBtn",
                  {
                    attrs: {
                      color: "primary",
                      to: {
                        name: "dataset",
                        params: { id: FileResults[0].FileId },
                      },
                    },
                  },
                  [_vm._v("\n        View uploaded file\n      ")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          ref: "addFileDialog",
          attrs: { persistent: "", "max-width": "750px" },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("DataSetAddFileDialog.addTitleMsg"))),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-stepper",
                    {
                      staticStyle: { "box-shadow": "none" },
                      model: {
                        value: _vm.step,
                        callback: function ($$v) {
                          _vm.step = $$v
                        },
                        expression: "step",
                      },
                    },
                    [
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                wrap: "",
                                row: "",
                                "justify-space-between": "",
                                "align-space-around": "",
                              },
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md12: "" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      ref: "form_step1",
                                      model: {
                                        value: _vm.formStepOneIsValid,
                                        callback: function ($$v) {
                                          _vm.formStepOneIsValid = $$v
                                        },
                                        expression: "formStepOneIsValid",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            "align-self-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-input",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "File Name",
                                                  name: "filename",
                                                  rules: _vm.fileNameRules,
                                                },
                                                model: {
                                                  value: _vm.filename,
                                                  callback: function ($$v) {
                                                    _vm.filename = $$v
                                                  },
                                                  expression: "filename",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            "align-self-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-input",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: "File Type",
                                                  disabled:
                                                    _vm.isAutoDetectFileType,
                                                  items: _vm.schemaSelectItems,
                                                  rules: _vm.fileSchemaRules,
                                                },
                                                model: {
                                                  value: _vm.fileSchemaName,
                                                  callback: function ($$v) {
                                                    _vm.fileSchemaName = $$v
                                                  },
                                                  expression: "fileSchemaName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.genericTypeSchema
                                        ? _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                "align-self-center": "",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-input",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      color: "primary",
                                                      "persistent-hint": "",
                                                      hint: "Determines the file type based on its contents (currently supports A125 and Hatfield EDDs only).",
                                                      label:
                                                        "Auto-detect file type",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.isAutoDetectFileType,
                                                      callback: function ($$v) {
                                                        _vm.isAutoDetectFileType =
                                                          $$v
                                                      },
                                                      expression:
                                                        "isAutoDetectFileType",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                "align-self-center": "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        large: "",
                                                        color: "warning",
                                                      },
                                                    },
                                                    [_vm._v("warning")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      Auto-detect is not available because 'Generic' file schema does not exist. \n                    "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "v-input",
                                        { staticStyle: { display: "none" } },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              disabled: "",
                                              name: "isUploadCompleted",
                                              rules: _vm.isUploadCompletedRules,
                                            },
                                            model: {
                                              value: _vm.isUploadCompleted,
                                              callback: function ($$v) {
                                                _vm.isUploadCompleted = $$v
                                              },
                                              expression: "isUploadCompleted",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            grow: "",
                                            "align-self-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "ma-0 mb-2",
                                              attrs: {
                                                color: "warning lighten-2",
                                                icon: "warning",
                                                outline: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text py-2",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "DataSetAddFileDialog.fileSizeLimitWarningMsg"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-input", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { width: "100%" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.uploadPrepare(
                                                      $event
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "uploader",
                                                  {
                                                    key: _vm.componentKey,
                                                    ref: "myUpload",
                                                    attrs: {
                                                      "end-point":
                                                        "api/RawDataRepository/UpoadFile",
                                                      disabled: _vm.isUploading,
                                                      showProgressBar: true,
                                                      multipart: true,
                                                      showErrors: false,
                                                      maxFileSize:
                                                        _vm.maxFileSize,
                                                      fileSizeExceededMsg:
                                                        _vm.$t(
                                                          "DataSetAddFileDialog.fileSizeExceededMsg"
                                                        ),
                                                      headers: {
                                                        uploadFileIdentifier:
                                                          _vm.uploadFileIdentifier,
                                                      },
                                                    },
                                                    on: {
                                                      fileUploaded:
                                                        _vm.fileUploaded,
                                                      error: _vm.uploadFailed,
                                                      startUpload:
                                                        _vm.startUpload,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          slot: "browse-btn",
                                                        },
                                                        slot: "browse-btn",
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              disabled: false,
                                                              color:
                                                                "blue-grey",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                Upload"
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  rightdark: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-cloud-upload"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.selectedFileName !=
                                                        null
                                                          ? _c("v-text-field", {
                                                              attrs: {
                                                                value:
                                                                  _vm.selectedFileName,
                                                                disabled: "",
                                                                label:
                                                                  "Selected File Name",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                value: _vm.isUploading,
                                                color: "warning lighten-2",
                                                icon: "warning",
                                                outline: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text py-2",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "DataSetAddFileDialog.uploadingTipsMsg"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                value: _vm.isUploadCompleted,
                                                color: "success lighten-2",
                                                icon: "check_circle",
                                                outline: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text py-2",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "DataSetAddFileDialog.uploadedTipsMsg"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form_step2",
                              model: {
                                value: _vm.formStepTwoIsValid,
                                callback: function ($$v) {
                                  _vm.formStepTwoIsValid = $$v
                                },
                                expression: "formStepTwoIsValid",
                              },
                            },
                            [
                              _c("data-set-file-metadata-inputs", {
                                ref: "metadata-inputs",
                                attrs: {
                                  schema: _vm.fileSchemaObject,
                                  disableAddButton: !_vm.formStepTwoIsValid,
                                },
                                on: { input: _vm.emitMetadataInput },
                                model: {
                                  value: _vm.metadataFields,
                                  callback: function ($$v) {
                                    _vm.metadataFields = $$v
                                  },
                                  expression: "metadataFields",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", disabled: !_vm.isValidForm },
                      on: {
                        click: function ($event) {
                          return _vm.proceed()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v(
                        _vm._s(
                          _vm.step == 1
                            ? _vm.$t("Button.Next")
                            : _vm.$t("Button.Create")
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600" },
          model: {
            value: _vm.exitConfirmDialog,
            callback: function ($$v) {
              _vm.exitConfirmDialog = $$v
            },
            expression: "exitConfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(_vm.$t("DataSetAddFileDialog.exitDialogTitleMsg"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.exitConfirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.isUploading
                        ? _vm.$t(
                            "DataSetAddFileDialog.exitDialogUploadingTipsMsg"
                          )
                        : _vm.isUploadCompleted
                        ? _vm.$t(
                            "DataSetAddFileDialog.exitDialogUploadCompletedTipsMsg"
                          )
                        : ""
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "delete", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.cleanUpUploadedFile()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Confirm")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.exitConfirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }